import { Fade, Modal, Backdrop } from "@mui/material"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import { L2RButton } from "../L2RButton"

import * as Styled from "./ConfirmDialog.styled"

export const ConfirmDialog = (props) => {

    const {
        cancelText,
        className,
        close,
        closeWithCallbacks,
        confirmText,
        id,
        onlyConfirm,
        open,
        text,
        title,
    } = props

    return <Modal
        slots={{
            backdrop: Backdrop,
        }}
        slotProps={{
            backdrop: { timeout: 500 },
        }}
        closeAfterTransition
        open={open}
        onClose={close}
        id={id ?? "alert"}
    >
        <Fade in={open}>
            <Styled.Wrapper className={className}>
                {title && <Styled.Title id="alert-title" variant="Desktop & Mobile/Heading/H2">
                    {title}
                </Styled.Title>}
                {text && <Styled.Text id="alert-text" variant="Desktop & Mobile/Body/Regular">
                    {`${text}`}
                </Styled.Text>}
                <Styled.ButtonWrapper>
                    {!onlyConfirm && close && cancelText && <L2RButton
                        id="alert-cancel-button"
                        onClick={close}
                        variant="tertiary"
                    >
                        {cancelText}
                    </L2RButton>}
                    {closeWithCallbacks && confirmText && <L2RButton
                        id="alert-confirm-button"
                        onClick={closeWithCallbacks}
                        autoFocus
                    >
                        {confirmText}
                    </L2RButton>}
                </Styled.ButtonWrapper>
            </Styled.Wrapper>
        </Fade>
    </Modal>
}

ConfirmDialog.propTypes = {
    cancelText: PropTypes.string,
    className: PropTypes.string,
    close: PropTypes.func,
    closeWithCallbacks: PropTypes.func,
    confirmText: PropTypes.string,
    id: PropTypes.string,
    onlyConfirm: PropTypes.bool,
    open: PropTypes.bool,
    text: PropTypes.string,
    title: PropTypes.string,
}